import { useEffect, useState, useContext } from 'react'
import { AuthContext } from '../contexts'

interface IUseAuthProps {
  authToken: string
}
type UseAuthProps = IUseAuthProps

export const useAuth = (): UseAuthProps => {
  const { authState } = useContext(AuthContext)
  const [authToken, setAuthToken] = useState(authState.authToken)

  useEffect(() => {
    setAuthToken(authState.authToken)
  }, [authState.authToken])

  return {
    authToken
  }
}
